
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Mumbaitomahabaleshwer() {



  const cardData =
  {
    keyword: ' Mumbai To Mahabaleshwar Cab',
    heading: 'SHREE Tours & Travels: Mumbai To Mahabaleshwar Cab',
    headingDescription: 'SHREE Tours & Travels offers a reliable Mumbai to Mahabaleshwar Cab service, ensuring a smooth and comfortable journey to the serene hill station. Whether you are planning a relaxing getaway, a family trip, or a romantic retreat, our well-maintained Cabs and professional drivers provide a hassle-free travel experience. Enjoy the scenic drive with on-time pickups, flexible booking options and affordable fares. Choose SHREE Tours & Travels for a safe and enjoyable Mumbai to Mahabaleshwar ride.',

    top: 'Top Places to Visit in Mahabaleshwar with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Venna Lake",
        "description": "Venna Lake is one of Mahabaleshwar’s most popular attractions, offering boating, horse riding and picturesque sunset views. Surrounded by lush greenery, this serene lake is a perfect spot for families and couples looking to unwind. Visitors can enjoy paddle or row boating and food stalls nearby serve local delicacies like corn on the cob and strawberries with cream."
    },
    {
        "title": "Elephant’s Head Point",
        "description": "Elephant’s Head Point is a breathtaking viewpoint named after its unique rock formation resembling an elephant’s head and trunk. Located at the edge of the Sahyadri mountain range, it offers panoramic views of the valleys and the deep gorges below. It's an ideal location for nature lovers and photography enthusiasts."
    },
    {
        "title": "Pratapgad Fort",
        "description": "Pratapgad Fort is a historic fort located about 24 km from Mahabaleshwar. Built by Chhatrapati Shivaji Maharaj in 1656, the fort played a crucial role in the Maratha-Mughal battles. Visitors can explore the ancient fortifications, witness the stunning views from the ramparts and visit the Bhavani Temple inside. Trekking up to the fort is an adventure that history buffs and thrill-seekers will enjoy."
    },
    {
        "title": "Arthur’s Seat",
        "description": "Arthur’s Seat is one of the most famous viewpoints in Mahabaleshwar, offering a mesmerizing view of the Savitri River valley on one side and the lush green forests on the other. Known as the ‘Queen of all Points,’ it is popular for its floating rock phenomenon and the dramatic landscape changes during sunrise and sunset."
    },
    {
        "title": "Mapro Garden",
        "description": "Mapro Garden is a paradise for fruit lovers and food enthusiasts. Known for its delicious strawberry produce, visitors can enjoy fresh strawberry shakes, ice creams and a variety of jams and syrups. The garden also has a play area for kids and a charming café where guests can relax while enjoying farm-fresh delights."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Lingmala Waterfall is a stunning natural wonder where water cascades down from a height of 600 feet. Surrounded by dense forests, this waterfall is best visited during the monsoon and post-monsoon seasons when it is at its most majestic. There are two viewpoints – one for the main waterfall and another for a smaller cascade where visitors can dip their feet in the cool waters."
    },
    {
        "title": "Wilson Point",
        "description": "Wilson Point, also known as Sunrise Point, is the highest point in Mahabaleshwar at 4,710 feet above sea level. It offers a 360-degree view of the surrounding hills and valleys, making it the best spot to catch a spectacular sunrise. The crisp mountain air and peaceful ambiance make it a must-visit for early risers and photography lovers."
    },
    {
        "title": "Panchgani",
        "description": "Located just a short drive from Mahabaleshwar, Panchgani is a charming hill station famous for its colonial-era architecture, strawberry farms and scenic views. Attractions like Table Land, Sydney Point and Parsi Point offer breathtaking landscapes. Visitors can enjoy paragliding, horse riding and visits to various strawberry farms to taste fresh produce."
    },
    {
        "title": "Connaught Peak",
        "description": "Connaught Peak is the second-highest peak in Mahabaleshwar, offering breathtaking views of Venna Lake, Krishna Valley and Pratapgad Fort. Named after the Duke of Connaught, this viewpoint is a lesser-known gem, perfect for those seeking solitude and a serene natural escape. The trek to the peak is short but rewarding with stunning sunset views."
    },
    {
        "title": "Bhilar Waterfall",
        "description": "Bhilar Waterfall is a seasonal waterfall that comes alive during the monsoon months, offering a refreshing retreat amidst nature. Surrounded by thick forests, the cascading waters create a soothing ambiance, making it an ideal place for a short trek, picnic, or just relaxing in the lap of nature."
    }
],  
    
            
"services": [
    {
      "name": "Mumbai to Mahabaleshwar Taxi",
      "description": "Travel comfortably from Mumbai to Mahabaleshwar by booking a taxi with SHREE Tours & Travels. Enjoy a smooth journey in our well-maintained vehicles with experienced drivers."
    },
    {
      "name": "Mumbai to Mahabaleshwar Cab Service",
      "description": "Book a reliable Cab service for your journey from Mumbai to Mahabaleshwar. We offer one-way and round-trip Cab options with comfortable seating and professional drivers."
    },
    {
      "name": "Mumbai to Mahabaleshwar One-Way Taxi",
      "description": "Need a one-way taxi from Mumbai to Mahabaleshwar? Enjoy a convenient and affordable ride with SHREE Tours & Travels, offering cost-effective one-way travel."
    },
    {
      "name": "Mumbai to Mahabaleshwar Round Trip Cab",
      "description": "Planning a round trip from Mumbai to Mahabaleshwar? Book a round-trip taxi with us for a flexible travel experience and a comfortable return journey."
    },
    {
      "name": "Affordable Mumbai to Mahabaleshwar Cab",
      "description": "Looking for an affordable Cab from Mumbai to Mahabaleshwar? We offer budget-friendly travel options without compromising on comfort and quality."
    },
    {
      "name": "Private Taxi for Mahabaleshwar from Mumbai",
      "description": "Book a private taxi from Mumbai to Mahabaleshwar for a personalized travel experience. Enjoy the luxury of traveling in your own space, with professional drivers and comfort."
    },
    {
      "name": "Mahabaleshwar Tour from Mumbai by Cab",
      "description": "Explore Mahabaleshwar with our dedicated tour service from Mumbai. Enjoy a memorable trip with professional drivers who offer sightseeing and local insights."
    },
    {
      "name": "Mahabaleshwar Cab Hire",
      "description": "Hire a comfortable and reliable Cab for your Mumbai to Mahabaleshwar journey. We offer different vehicle options for your convenience and comfort."
    },
    {
      "name": "Group Travel from Mumbai to Mahabaleshwar",
      "description": "Traveling in a group? We provide spacious Cabs for smooth and comfortable group travel from Mumbai to Mahabaleshwar. Enjoy your trip together!"
    },
    {
      "name": "Book Mumbai to Mahabaleshwar Car",
      "description": "Rent a car for your Mumbai to Mahabaleshwar trip with ease. Choose from a variety of cars like sedans, SUVs and tempo travelers for your convenience."
    },
    {
      "name": "Mahabaleshwar Cab Booking from Mumbai",
      "description": "Book your Cab from Mumbai to Mahabaleshwar easily and quickly. Our reliable service ensures timely pickups and smooth rides with professional drivers."
    },
    {
      "name": "Mahabaleshwar Weekend Trip from Mumbai",
      "description": "Planning a weekend getaway? Book a comfortable taxi for a quick and relaxing weekend trip from Mumbai to Mahabaleshwar with our flexible services."
    },
    {
      "name": "Luxury Mahabaleshwar Cab",
      "description": "Travel in style with our luxury Cabs from Mumbai to Mahabaleshwar. Choose from premium vehicles for a lavish and comfortable journey."
    },
    {
      "name": "Mahabaleshwar Sightseeing Tour",
      "description": "Discover the beauty of Mahabaleshwar with our sightseeing Cab service. Explore the top tourist attractions with an experienced driver for a hassle-free experience."
    }
  ],

  "tableData": [
    ["- Mumbai to Mahabaleshwar Taxi", "- Mumbai to Mahabaleshwar Cab Service"],
    ["- Mumbai to Mahabaleshwar One-Way Taxi", "- Mumbai to Mahabaleshwar Round Trip Cab"],
    ["- Affordable Mumbai to Mahabaleshwar Cab", "- Private Taxi for Mahabaleshwar from Mumbai"],
    ["- Mahabaleshwar Tour from Mumbai by Cab", "- Mahabaleshwar Cab Hire"],
    ["- Group Travel from Mumbai to Mahabaleshwar", "- Book Mumbai to Mahabaleshwar Car"],
    ["- Mahabaleshwar Cab Booking from Mumbai", "- Mahabaleshwar Weekend Trip from Mumbai"],
    ["- Luxury Mahabaleshwar Cab", "- Mahabaleshwar Sightseeing Tour"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Scenic and Comfortable Journey",
      "WhyChoosedescription": "Our Mumbai to Mahabaleshwar Cab service offers a scenic and comfortable ride, allowing you to enjoy the beautiful landscapes as you travel. With spacious seating, air-conditioning and smooth driving, your journey to the hill station will be a pleasant and relaxing experience."
    },
    {
      "WhyChooseheading": "Experienced and Knowledgeable Drivers",
      "WhyChoosedescription": "Our professional drivers are well-versed in the best routes from Mumbai to Mahabaleshwar, ensuring a safe and smooth journey. They are dedicated to providing a hassle-free ride while prioritizing your comfort and safety throughout the trip."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer competitive and transparent pricing for your Mumbai to Mahabaleshwar Cab ride. There are no hidden fees and we strive to provide the best value for your money. Whether you’re booking a one-way or round trip, our pricing is designed to be budget-friendly."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to ensure a safe and comfortable journey. From mechanical checks to cleanliness, we ensure that each vehicle is in top condition, allowing you to travel with peace of mind and comfort."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Mahabaleshwar Cab is easy and convenient with SHREE Tours & Travels. You can book online through our user-friendly platform or contact our customer service team for assistance. Whether you're booking last minute or in advance, we ensure a hassle-free experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Mumbai to Mahabaleshwar Cab ride. Whether you're planning an early morning departure or a late-night return, we are ready to accommodate your travel schedule with our round-the-clock service."
    },
    {
      "WhyChooseheading": "Local Expertise",
      "WhyChoosedescription": "Our drivers have great knowledge of the routes and attractions between Mumbai and Mahabaleshwar. They can suggest scenic stops along the way or provide insights into the best places to visit in Mahabaleshwar, making your trip even more enjoyable."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We ensure that your Mumbai to Mahabaleshwar Cab ride is comfortable, safe and on time. With our commitment to quality service, we guarantee a pleasant and stress-free experience every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Mumbai to Mahabaleshwar?",
        answer: "You can easily book your Mumbai to Mahabaleshwar Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Mumbai to Mahabaleshwar route?",
        answer: "We offer a variety of vehicles for the Mumbai to Mahabaleshwar journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Mumbai to Mahabaleshwar inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Mumbai to Mahabaleshwar?",
        answer: "Yes, we offer one-way rental options for your Mumbai to Mahabaleshwar trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Mumbai to Mahabaleshwar trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Mumbai to Mahabaleshwar Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Mumbai to Mahabaleshwar Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Mumbai to Mahabaleshwar trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Mumbai to Mahabaleshwar?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Mumbai to Mahabaleshwar?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Mumbai to Mahabaleshwar journey was amazing! The driver was courteous and the vehicle was very comfortable throughout the trip.',
        name: 'Mr. Prakash Rao',
    },
    {
        text: 'I had an excellent experience with SHREE Tours & Travels. The trip to Mahabaleshwar was smooth and the driver was very knowledgeable about the route.',
        name: 'Miss. Neelam Shah',
    }
];










  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Mumbai to Mahabaleshwar Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/mumbai-to-mahabaleshwar-cab.jpg",
    "https://shreetoursandtravels.in/img/mahabaleshwar-tour-cab.jpg"
  ],
  "priceRange": "₹3500 - ₹6000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/mumbai-to-mahabaleshwar-cab-service",
    "priceCurrency": "INR",
    "price": 4500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 1100
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Amit Deshmukh"
      },
      "datePublished": "2024-10-15",
      "reviewBody": "The Mumbai to Mahabaleshwar trip was amazing. The driver was experienced and the ride was comfortable. Highly recommend SHREE Tours & Travels for this route."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Sharma"
      },
      "datePublished": "2024-11-01",
      "reviewBody": "Excellent service and a smooth ride! Our family had a great time traveling to Mahabaleshwar from Mumbai. Will book again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Mumbai to Mahabaleshwar Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.0760,  // Mumbai latitude
      "longitude": 72.8777  // Mumbai longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/mumbai-to-mahabaleshwar-cab-service"
  },
  "keywords": "Mumbai to Mahabaleshwar Taxi, Mumbai to Mahabaleshwar Cab Service, Mumbai to Mahabaleshwar One-Way Taxi, Mumbai to Mahabaleshwar Round Trip Cab, Affordable Mumbai to Mahabaleshwar Cab, Private Taxi for Mahabaleshwar from Mumbai, Mahabaleshwar Tour from Mumbai by Cab, Mahabaleshwar Cab Hire, Group Travel from Mumbai to Mahabaleshwar, Book Mumbai to Mahabaleshwar Car, Mahabaleshwar Cab Booking from Mumbai, Mahabaleshwar Weekend Trip from Mumbai, Luxury Mahabaleshwar Cab, Mahabaleshwar Sightseeing Tour"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Mumbai to Mahabaleshwar Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Mumbai to Mahabaleshwar Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Mumbai to Mahabaleshwar Taxi, Mumbai to Mahabaleshwar Cab Service, Mumbai to Mahabaleshwar One-Way Taxi, Mumbai to Mahabaleshwar Round Trip Cab, Affordable Mumbai to Mahabaleshwar Cab, Private Taxi for Mahabaleshwar from Mumbai, Mahabaleshwar Tour from Mumbai by Cab, Mahabaleshwar Cab Hire, Group Travel from Mumbai to Mahabaleshwar, Book Mumbai to Mahabaleshwar Car, Mahabaleshwar Cab Booking from Mumbai, Mahabaleshwar Weekend Trip from Mumbai, Luxury Mahabaleshwar Cab, Mahabaleshwar Sightseeing Tour" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/11.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitomahabaleshwer;